import { CsvData } from '../types/CsvData'

export function dataHeaderToColumn(data: CsvData, header: string) {
  const headerIndex = data.headers.indexOf(header)
  return data.rows.map((row) => row[headerIndex])
}
